import React from "react"

const FruehbucherRabatt = (props) => {
  if (props.rabatt === null || "&nbsp;") {
    return <div></div>
  } else {
    return (
      <div
        className="fruehbucher-rabatt"
        dangerouslySetInnerHTML={{
          __html: props.rabatt.childMarkdownRemark.html,
        }}
      ></div>
    )
  }
}
export default FruehbucherRabatt
